export default __webpack_public_path__ + "static/media/won-bg.ec84c1da.png";